module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('p', {
    staticClass: "C333",
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('strong', [_vm._v("CUE-TITLES")])]), _vm._v(" "), _c('p', {
    staticClass: "C362"
  }, [_c('strong', [_vm._v("A. Manuscript locations")])]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "C393",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', {
    staticClass: "T317_FirstRow"
  }, [_c('td', {
    staticClass: "C424",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("ColU")]), _vm._v(" "), _c('td', {
    staticClass: "C425",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("Columbia University")])]), _vm._v(" "), _c('tr', {
    staticClass: "T317_Row"
  }, [_c('td', {
    staticClass: "C403",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("UIll")]), _vm._v(" "), _c('td', {
    staticClass: "C401",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("University of Illinois at Urbana–Champaign")])]), _vm._v(" "), _c('tr', {
    staticClass: "T317_Row"
  }, [_c('td', {
    staticClass: "C403",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("UT")]), _vm._v(" "), _c('td', {
    staticClass: "C401",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("University of Texas at Austin")])]), _vm._v(" "), _c('tr', {
    staticClass: "T317_LastRow"
  }, [_c('td', {
    staticClass: "C403",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("YU")]), _vm._v(" "), _c('td', {
    staticClass: "C401",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("Yale University")])])])]), _vm._v(" "), _c('p', {
    staticClass: "C362"
  }, [_c('strong', [_vm._v("B. Printed works")])]), _vm._v(" "), _c('p', {
    staticClass: "C345"
  }, [_vm._v("(The place of publication, here and throughout, is London unless otherwise stated.)")]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "C393",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', {
    staticClass: "T317_FirstRow"
  }, [_c('td', {
    staticClass: "C426",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('em', [_vm._v("Aaron's Rod")])]), _vm._v(" "), _c('td', {
    staticClass: "C428",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("D. H. Lawrence. "), _c('em', [_vm._v("Aaron's Rod")]), _vm._v(". Ed. Mara Kalnins. Cambridge: Cambridge University Press, 1988.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T318_Row"
  }, [_c('td', {
    staticClass: "C403",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('em', [_vm._v("Complete Poems")])]), _vm._v(" "), _c('td', {
    staticClass: "C401",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Vivian de Sola Pinto and Warren Roberts, eds. "), _c('em', [_vm._v("The Complete Poems of D. H. Lawrence")]), _vm._v(". 2 volumes. Heinemann, 1964.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T318_Row"
  }, [_c('td', {
    staticClass: "C403",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("Lacy, "), _c('em', [_vm._v("Seltzer")])]), _vm._v(" "), _c('td', {
    staticClass: "C401",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Gerald M. Lacy, ed. "), _c('em', [_vm._v("D. H. Lawrence: Letters to Thomas and Adele Seltzer")]), _vm._v(". Santa Barbara: Black Sparrow Press, 1976.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T318_Row"
  }, [_c('td', {
    staticClass: "C403",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('em', [_vm._v("Letters")]), _vm._v(", i.")]), _vm._v(" "), _c('td', {
    staticClass: "C401",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("James T. Boulton, ed. "), _c('em', [_vm._v("The Letters of D. H. Lawrence")]), _vm._v(". Volume I. Cambridge: Cambridge University Press, 1979.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T318_Row"
  }, [_c('td', {
    staticClass: "C403",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('em', [_vm._v("Letters")]), _vm._v(", ii.")]), _vm._v(" "), _c('td', {
    staticClass: "C401",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("George J. Zytaruk and James T. Boulton, eds. "), _c('em', [_vm._v("The Letters of D. H. Lawrence")]), _vm._v(". Volume II. Cambridge: Cambridge University Press, 1981.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T318_Row"
  }, [_c('td', {
    staticClass: "C403",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('em', [_vm._v("Letters")]), _vm._v(", iii.")]), _vm._v(" "), _c('td', {
    staticClass: "C401",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("James T. Boulton and Andrew Robertson, eds. "), _c('em', [_vm._v("The Letters of D. H. Lawrence")]), _vm._v(". Volume III. Cambridge: Cambridge University Press, 1984.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T318_Row"
  }, [_c('td', {
    staticClass: "C403",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('em', [_vm._v("Letters")]), _vm._v(", iv.")]), _vm._v(" "), _c('td', {
    staticClass: "C401",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Warren Roberts, James T. Boulton and Elizabeth Mansfield, eds. "), _c('em', [_vm._v("The Letters of D. H. Lawrence")]), _vm._v(". Volume IV. Cambridge: Cambridge University Press, 1987.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T318_Row"
  }, [_c('td', {
    staticClass: "C403",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('em', [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _vm._v("Letters")]), _vm._v(", v.")]), _vm._v(" "), _c('td', {
    staticClass: "C401",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("James T. Boulton and Lindeth Vasey, eds. "), _c('em', [_vm._v("The Letters of D. H. Lawrence")]), _vm._v(". Volume V. Cambridge: Cambridge University Press, 1989.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T318_Row"
  }, [_c('td', {
    staticClass: "C403",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('em', [_vm._v("Movements")])]), _vm._v(" "), _c('td', {
    staticClass: "C401",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("D. H. Lawrence. "), _c('em', [_vm._v("Movements in European History")]), _vm._v(". Ed. Philip Crumpton. Cambridge: Cambridge University Press, 1989.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T318_Row"
  }, [_c('td', {
    staticClass: "C403",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('em', [_vm._v("Phoenix")])]), _vm._v(" "), _c('td', {
    staticClass: "C401",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Edward D. McDonald, ed. "), _c('em', [_vm._v("Phoenix: The Posthumous Papers of D. H. Lawrence")]), _vm._v(". New York: Viking, 1936.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T318_Row"
  }, [_c('td', {
    staticClass: "C403",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('em', [_vm._v("Phoenix II")])]), _vm._v(" "), _c('td', {
    staticClass: "C401",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Warren Roberts and Harry T. Moore, eds. "), _c('em', [_vm._v("Phoenix II: Uncollected, Unpublished and Other Prose Works by D. H. Lawrence")]), _vm._v(". Heinemann, 1968.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T318_Row"
  }, [_c('td', {
    staticClass: "C403",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("Roberts")]), _vm._v(" "), _c('td', {
    staticClass: "C401",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Warren Roberts. "), _c('em', [_vm._v("A Bibliography of D. H. Lawrence")]), _vm._v(". 2nd edn. Cambridge: Cambridge University Press, 1982.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T318_LastRow"
  }, [_c('td', {
    staticClass: "C403",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("Tedlock, "), _c('em', [_vm._v("Lawrence MSS")])]), _vm._v(" "), _c('td', {
    staticClass: "C401",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("E. W. Tedlock. "), _c('em', [_vm._v("The Frieda Lawrence Collection of D. H. Lawrence Manuscripts: A Descriptive Bibliography")]), _vm._v(". Albuquerque: University of New Mexico Press, 1948.")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34c6a520","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Cue_titles.vue
// module id = 84
// module chunks = 0